import React from 'react';
import BarLoader from 'react-spinners/BarLoader';

import styles from './Spinner.module.scss';

function Spinner() {
  return (
    <div className={styles.Spinner__container} data-testid="Spinner">
      <BarLoader color="#666" size="16px" loading={true} />
    </div>
  );
}

export default Spinner;
